import React, { Component } from 'react';

import './App.css';

import { ChatSideBar } from './components/ChatSideBar';
import { GameScreen } from './components/GameScreen/GameScreen';

class App extends Component {

  render() {
    return (
      <ChatSideBar >
        <div className="App">
          <GameScreen />
        </div>
      </ChatSideBar>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js